/*
* Project: LegalPlace assistant
* File: src/components/save_component_section.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/


import React, { Component } from 'react';
import { connect } from 'react-redux';
// importing things
import { LP_STATE_PAYMENT, LP_STATE_WIZARD, setAppState } from '../redux/actions/app_state';
import { updateMailFromInput } from '../redux/actions/account_settings';
// import { saveMail } from '../logic/firebase/account';
import { _lp } from '../logic/wording';
import lpApp from '../app/lp_app';
import LpPayment from '../logic/payment';

// the check of mail existance here
class _SaveSection extends Component {
  constructor(props) {
    super(props);
    this.updateMyMail = this.updateMyMail.bind(this);
    this.toThePayment = this.toThePayment.bind(this);
    this.has_error = false;
    // The initialization of payment system while the guy writes down the mail
    if (typeof window.lp_payment === 'undefined') {
      window.lp_payment = new LpPayment();
    }
  }

  updateMyMail(evt){
    // console.log(evt.target.value);
    this.props.updateMail(evt.target.value);
  }

  toThePayment() {
    // saveMail(this.props.value);
    // this.props.pass0(this.props.value);
    this.props.goForward();
  }

  render() {
    return (
      <div className="wizard-content" style={{}}>
        {this.props.document_id === '' ? (
          <div>

            <p style={{ fontSize: '18px', fontWeight: "600", marginTop: '45px' }}>
              {
                lpApp.references.customs.get('save_section_text') === 'NONE' ? _lp('Renseignez votre adresse email afin de retrouver vos réponses lors de votre prochaine visite') : lpApp.references.customs.get('save_section_text')
              }
            </p>
            <div className="wizard-email" style={{marginLeft: "15px"}}>
              <div className={`form-group${this.props.has_error ? ' error' : ''}`}>
                <label>{lpApp.references.customs.get('save_section_label') === 'NONE' ? _lp('Adresse email') : lpApp.references.customs.get('save_section_label')}</label>
                <input type="mail" name="email" onChange={evt => this.updateMyMail(evt)} value={this.props.value} className="form-control" />
                {this.props.has_error && <span className="help-block">{_lp('Veuillez saisir une adresse email valide.')}</span>}
                <span className="helper">
                  <i className="icn-info-o" />
                  {lpApp.references.customs.get('save_section_info') === 'NONE' ? _lp('Nous ne partagerons vos informations avec personne') : lpApp.references.customs.get('save_section_info')}
                </span>
              </div>
            </div>

            <p style={{ fontSize: '0.8em', marginTop: '75px' }}>
              {_lp('Conformément à la Loi Informatique et Libertés et Règlement général sur la protection des données (RGPD), vous disposez d’un droit d’accès, de modification, de suppression et d’opposition au traitement de vos données à caractère personnel.')}
            </p>
          </div>
        )
          : (
            <p className="we-law" style={{ fontSize: '18px', fontWeight: "600", marginTop: '45px' }}>
              {lpApp.references.customs.get('save_section_success_message') === 'NONE' ? _lp('Un email de confirmation vous a été envoyé contenant un lien pour reprendre votre questionnaire') : lpApp.references.customs.get('save_section_success_message')}
            </p>
          )

        }
      </div>
    );
  }
}


const mapStateToProps = state => ({
  value: state.account_settings.mail,
  has_error: state.error.mail,
  document_id: state.document_state.unique,
});

const mapDispatchToProps = dispatch => ({
  goForward: () => {
    // check the existance here
    dispatch(setAppState(LP_STATE_PAYMENT));
  },
  goBackward: () => {
    dispatch(setAppState(LP_STATE_WIZARD));
  },
  updateMail: (val) => {
    dispatch(updateMailFromInput(val));
  },
  pass0: () => {},
});

const SaveSection = connect(mapStateToProps, mapDispatchToProps)(_SaveSection);

export default SaveSection;



// WEBPACK FOOTER //
// ./src/components/save_component_section.js